// PathTracker.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent, trackPageViewed } from "../lib/mixpanel";
import { gaPageView } from "../utils/gaAnalytics";

function PathTracker() {
  const location = useLocation();

  useEffect(() => {
    let history = JSON.parse(localStorage.getItem("pathHistory")) || [];

    history.push(location.pathname);

    if (history.length > 5) {
      history = history.slice(history.length - 5);
    }

    localStorage.setItem("pathHistory", JSON.stringify(history));

    trackPageViewed(location.pathname);
    gaPageView(location.pathname + location.search);
    if (location.pathname === "/pricing") {
      trackEvent("paywall_viewed");
    }
  }, [location]);

  return null;
}

export default PathTracker;
